import SeoAuditExperience from "../components/SeoAuditExperience";

export default function LoggedInSeoAudit() {
  return <SeoAuditExperience mode="app" />;
}
